var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTouchhand36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-touch_hand-36",
    "data-name": "icon-touch hand-36",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7348",
    "data-name": "Rectangle 7348",
    width: 36,
    height: 36,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(20787.189 21874.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "touch-icon",
    transform: "translate(-20778.453 -21863.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M9.409,41.787a.776.776,0,0,1-.092-.057c-.37-.293-.777-.623-1.126-.908-.511-.419-1.1-.9-1.511-1.246a2.151,2.151,0,0,0-.9-.454.966.966,0,0,0-.511.02.529.529,0,0,0-.273.28,1.76,1.76,0,0,0-.1.819,3.184,3.184,0,0,0,.28,1.015,6.365,6.365,0,0,0,.742,1.25.2.2,0,0,1,.035.057l4.426,6.322a.534.534,0,0,1,.1.265,4.036,4.036,0,0,0,.469,1.623.727.727,0,0,0,.65.37h6.964a2.081,2.081,0,0,0,1.188-.385,3.786,3.786,0,0,0,1.084-1.273.189.189,0,0,0,.02-.027c.127-.216.293-.5.454-.762a7.328,7.328,0,0,0,1.392-3.615L22.651,43.1a.324.324,0,0,1-.007-.084c0-.027,0-.216.007-.469.015-1.315.035-2.938-1.169-3.139h-.777c-.007.37-.027.749-.05,1.112-.02.328-.042.635-.042.938a.581.581,0,1,1-1.161,0c0-.3.02-.65.042-1.015.077-1.238.169-2.657-.819-2.831h-.769a.733.733,0,0,1-.127-.015c.007.447-.02.908-.05,1.357-.015.327-.035.635-.035.935a.581.581,0,0,1-1.161,0c0-.3.02-.65.042-1.015.077-1.238.169-2.657-.819-2.831h-.769a.607.607,0,0,1-.154-.02v2.258a.581.581,0,0,1-1.161,0V32.215a2.008,2.008,0,0,0-.943-1.923,1.345,1.345,0,0,0-.608-.146,1.378,1.378,0,0,0-.608.146,2.035,2.035,0,0,0-.93,1.95V42.864a.581.581,0,0,1-1.161,0V41.787H9.409Zm5.426-6.892a.513.513,0,0,1,.154-.02h.8a.762.762,0,0,1,.131.015,1.957,1.957,0,0,1,1.749,1.6.6.6,0,0,1,.246-.057h.8a.762.762,0,0,1,.131.015,1.986,1.986,0,0,1,1.784,1.784.353.353,0,0,1,.092-.007h.8a.82.82,0,0,1,.134.015c2.211.342,2.181,2.538,2.161,4.307v.461l.05,2.042v.062a8.249,8.249,0,0,1-1.558,4.168c-.134.216-.265.439-.447.749-.007.007-.007.015-.015.02a4.935,4.935,0,0,1-1.434,1.65,3.22,3.22,0,0,1-1.838.588H11.625a1.824,1.824,0,0,1-1.63-.881,4.66,4.66,0,0,1-.643-1.985l-4.334-6.2L5,43.2a7.957,7.957,0,0,1-.873-1.476,4.356,4.356,0,0,1-.377-1.407,2.858,2.858,0,0,1,.2-1.37,1.632,1.632,0,0,1,.9-.881,2,2,0,0,1,1.169-.084,3.27,3.27,0,0,1,1.419.7c.35.293.938.769,1.511,1.238l.476.392V32.25A3.135,3.135,0,0,1,11,29.263a2.487,2.487,0,0,1,2.265,0,3.133,3.133,0,0,1,1.588,2.965V34.9l-.017,0Z",
    transform: "translate(-3.737 -28.99)",
    fill: "#b6be34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -20778.453, -21869.191)",
    fill: "none",
    stroke: "#b6be34",
    strokeWidth: 1,
    strokeDasharray: "18 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.987,
    cy: 6.987,
    r: 6.987,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.987,
    cy: 6.987,
    r: 6.487,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    transform: "translate(-20776.268 -21865.676) rotate(-25)",
    fill: "none",
    stroke: "#b6be34",
    strokeWidth: 1,
    strokeDasharray: "11 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.446,
    cy: 4.446,
    r: 4.446,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.446,
    cy: 4.446,
    r: 3.946,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTouchhand36);
export default __webpack_public_path__ + "static/media/icon-touch hand-36.fcb04ec3d2fd20657eeb88d122c0c53f.svg";
export { ForwardRef as ReactComponent };